import styled from 'styled-components';

export const ToolboxItemContainer = styled.div`
  overflow: visible;
  position: relative;
  height: 2.5rem;
  display: flex;
  border-radius: 6px;
  align-items: center;
  gap: 0.5rem;
  padding: 0px 1rem;
  background: ${({ theme }) => theme.neutralLighter};
  cursor: pointer;

  & + div {
    border-left: 1px solid ${({ theme }) => theme.neutralLight};
  }

  > svg {
    width: 1rem;
    height: 1rem;
    object-fit: contain;
  }

  .controlWrapper {
    visibility: hidden;
    opacity: 0;
    transition: all 0.3s ease;
  }

  &:hover {
    background: ${({ theme }) => theme.themeLighter};

    .controlWrapper {
      visibility: visible;
      opacity: 1;
    }
  }
`;
